import {ComponentFactory, ComponentFactoryResolver, NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {SharedModule} from '../../../../app-common/shared.module';
import {SharedSearchModule} from '../../../../app-common/shared-search.module';
import {ElementIdDirective} from '../../directives/element-id.directive';
import {SearchLongDescriptionV2Component} from './components/search-long-description-v2/search-long-description-v2.component';
import {SearchShortDescriptionV2Component} from '../../components/search-short-description-v2/search-short-description-v2.component';
import {PaginationV2Component} from '../../../../components/pagination-v2/pagination-v2.component';
import {SearchCareproviderUnitItemLabelsComponent} from './components/search-careprovider-unit-item-labels/search-careprovider-unit-item-labels.component';
import {SearchBreadcrumbsService} from '../../services/search-breadcrumbs.service';
import {SearchConnectionsService} from '../../services/search-connections.service';
import {MapsModule} from '../../../../components/maps/maps.module';
import {CustomerFeatureComponent} from '../../../../components/careprovider/customer-feature/customer-feature.component';
import {BookingBtnComponent} from '../../../../components/booking-btn/booking-btn.component';
import {MatSelectModule} from '@angular/material/select';
import {MatOptionModule} from '@angular/material/core';
import {MatTooltipModule} from '@angular/material/tooltip';
import {SharedCareproviderModule} from '../../../../app-common/shared-careprovider.module';
import {SharedSerpModule} from '../shared-serp.module';
import {SearchV6Component} from './components/search-v6/search-v6.component';
import {MatTabLink, MatTabsModule} from '@angular/material/tabs';
import {CpruTabsService} from '../../../../services/cpru-tabs.service';
import {CareproviderUnitItemV5Component} from './components/careprovider-unit-item-v5/careprovider-unit-item-v5.component';
import {SearchCareproviderUnitItemImgV2Component} from './components/search-careprovider-unit-item-img-v2/search-careprovider-unit-item-img-v2.component';
import {CareproviderUnitItemServiceComponent} from './components/careprovider-unit-item-service/careprovider-unit-item-service.component';
import {TimeslotButtonComponent} from '../../../../components/careprovider/timeslot-button/timeslot-button.component';
import {SearchFaqComponent} from './components/search-faq/search-faq.component';
import {SearchResultsListV5Component} from './components/search-results-list-v5/search-results-list-v5.component';
import {CareproviderUnitItemHsaComponent} from './components/careprovider-unit-item-hsa/careprovider-unit-item-hsa.component';
import {SearchCareproviderUnitItemImgV3Component} from './components/search-careprovider-unit-item-img-v3/search-careprovider-unit-item-img-v3.component';
import {UiIconComponent} from '../../../../components/ui/ui-icon/ui-icon.component';
import {UiButtonComponent} from '../../../../components/ui/ui-button/ui-button.component';

const materialModules = [MatSelectModule, MatOptionModule, MatTooltipModule];

@NgModule({
  imports: [
    RouterModule,
    SharedModule,
    SharedSearchModule,
    // SearchWidgetV2Module,
    SharedCareproviderModule,
    MapsModule,
    CustomerFeatureComponent,
    BookingBtnComponent,
    ...materialModules,
    SharedSerpModule,
    MatTabLink,
    MatTabsModule,
    TimeslotButtonComponent,
    UiIconComponent,
    UiButtonComponent,
  ],
  declarations: [
    ElementIdDirective,
    SearchV6Component,
    SearchLongDescriptionV2Component,
    SearchShortDescriptionV2Component,
    PaginationV2Component,
    SearchCareproviderUnitItemImgV2Component,
    SearchCareproviderUnitItemImgV3Component,
    SearchCareproviderUnitItemLabelsComponent,
    SearchResultsListV5Component,
    CareproviderUnitItemV5Component,
    CareproviderUnitItemHsaComponent,
    CareproviderUnitItemServiceComponent,
    SearchFaqComponent,
  ],
  providers: [SearchBreadcrumbsService, SearchConnectionsService, CpruTabsService],
  exports: [SearchV6Component],
})
export class SerpV2Module {
  constructor(private resolver: ComponentFactoryResolver) {}

  resolveComponentFactory(): ComponentFactory<SearchV6Component> {
    return this.resolver.resolveComponentFactory(SearchV6Component);
  }
}
